import React, { useState, useEffect, useCallback } from 'react';
import { BanknotesIcon } from '@heroicons/react/24/outline';
import { bookingApi } from '../../../utils/bookingApi';
import { formatDate } from '../../../utils/dates';
import { PageHeader, Skeleton, EmptyState, ErrorState } from '../../../components/ui';
import '../booking-shared.css';
import './adminTables.css';

const ADMIN = { to: '/admin-hub', label: 'Admin' };

export default function AdminCharges() {
  const [charges, setCharges] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const load = useCallback(() => {
    setLoading(true);
    setError(false);
    bookingApi.getAdminCharges()
      .then(r => setCharges(r.data))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  let body;
  if (loading) body = <Skeleton rows={4} label="Loading charges…" />;
  else if (error) body = <ErrorState title="Couldn't load charges" onRetry={load} />;
  else if (charges.length === 0) {
    body = <EmptyState icon={BanknotesIcon} title="No charges yet" text="Charges added on a member's page show here, paid or not." />;
  } else {
    body = (
      <table className="bk-table ad-table">
        <thead>
          <tr>
            <th>Member</th>
            <th>Description</th>
            <th className="num">Amount</th>
            <th>Due date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {charges.map(c => (
            <tr key={c.id}>
              <td className="ad-card-title">{c.user.firstName} {c.user.lastName}</td>
              <td data-label="Description">{c.description}</td>
              <td className="num" data-label="Amount">£{(c.amount / 100).toFixed(2)}</td>
              <td className="ad-nowrap" data-label="Due">{formatDate(c.dueDate)}</td>
              <td className="ad-card-status">
                {c.paidAt
                  ? <span className="bk-pill bk-pill--good">{c.paidWithCredit ? 'Paid (credit)' : 'Paid'}</span>
                  : <span className="bk-pill bk-pill--wait">Unpaid</span>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  return (
    <div className="bk-page bk-page--wide">
      <PageHeader back={ADMIN} title="Charges" />
      {body}
    </div>
  );
}
